
<span [id]="id + '-title'" *ngIf="title" class="title">{{title}}</span>
<div [id]="id" class="container" [ngClass]="{'invalid': invalid, 'disabled': disabled}">
  <div class="tags-container" >
    <app-tags [id]="id + '-' + tag[value]" [removable]="!disabled" (remove)="removeTag(tag)" class="tag" *ngFor="let tag of tags; let a = index">{{tag[value]}}</app-tags>
  </div>
  
  <div class="open-btn" (click)="openDropdown()" [id]="id + '-arrow'">
    <img src="../../../../assets/svgs/dropdown_arrow_ico.svg" [ngClass]="{'icon-revert': isOpen && !disabled}" label="arrow-icon" alt="dropdown-arrow">
  </div> 
  <div class="dropdown-box" *ngIf="isOpen && !disabled">
    <div [id]="id + '-option-'+ i" (click)="checkItem(option, i)" *ngFor="let option of options; let i = index" class="item">
      <lib-input-checkbox
       class="checkbox"
       [(ngModel)]="option.checked"
       style="margin-right: 6px;"
       ></lib-input-checkbox>
       {{option[value]}}
    </div>
  </div>
</div>